import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { WithdrawalRequest } from "../models/transfer.model";

interface Props {
  tableTransaction: WithdrawalRequest[];
}

const tableStyles = `
  .custom-table-container {
    background: #ffffff;
    border-radius: 16px;
    box-shadow: 0 4px 24px rgba(0, 0, 0, 0.04);
    border: 1px solid #e8eaed;
    overflow: hidden;
    padding: 16px;
  }

  /* Fondo general de la tabla */
  .custom-table-container .p-datatable {
    background: #ffffff !important;
  }

  /* Reset y estilo de las cabeceras (Headers) */
  .custom-table-container .p-datatable .p-datatable-thead > tr > th {
    background: #f9fafb !important; /* Gris muy claro */
    color: #4b5563 !important;      /* Gris oscuro para el texto */
    border-bottom: 2px solid #e5e7eb !important; /* Línea divisoria gris */
    font-weight: 700 !important;
    text-transform: uppercase;
    font-size: 0.75rem;
    letter-spacing: 0.5px;
    padding: 14px 16px !important;
  }

  /* Reset y estilo de las celdas del cuerpo (Body) */
  .custom-table-container .p-datatable .p-datatable-tbody > tr {
    background: #ffffff !important;
    color: #1f2937 !important; /* Texto principal oscuro */
    transition: background-color 0.2s;
  }

  /* Efecto Hover en las filas con un sutil toque verde */
  .custom-table-container .p-datatable .p-datatable-tbody > tr:hover {
    background: #f0fdf4 !important; /* Fondo verde extremadamente suave */
  }

  .custom-table-container .p-datatable .p-datatable-tbody > tr > td {
    border-bottom: 1px solid #f3f4f6 !important; /* Bordes de filas grises */
    padding: 14px 16px !important;
    font-size: 0.85rem;
  }

  /* Estilo para el mensaje de tabla vacía */
  .custom-table-container .p-datatable .p-datatable-tbody > tr.p-datatable-emptymessage td {
    color: #9ca3af !important; /* Gris claro */
    text-align: center;
    padding: 32px !important;
    font-weight: 500;
    background: #ffffff !important;
  }
`;

function TableTransfer({ tableTransaction }: Props) {
  return (
    <>
      <style>{tableStyles}</style>
      <div className="custom-table-container">
        <DataTable
          value={tableTransaction}
          tableStyle={{ minWidth: "50rem" }}
          emptyMessage="No existen transacciones"
        >
          <Column field="idWithdrawalRequest" header="transacción id" />
          <Column
            field="idLottery"
            header="Concepto"
            body={(rowData) => (
              <p style={{ margin: 0 }}>
                {rowData?.lottery?.description || ""} Solicitud de retiro
              </p>
            )}
          />
          <Column field="dateWithdrawalRequest" header="Fecha registro" />
          <Column field="responseWithdrawalRequest" header="Respuesta" />
          <Column field="dateResponse" header="Fecha respuesta" />
        </DataTable>
      </div>
    </>
  );
}

export default TableTransfer;